export default "__VITE_ASSET__BzRgYj8___"